// 生成一周的日期标签
export const getWeekDays = () => {
  const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  const weekDays = [];
  const today = new Date();
  
  for (let i = 6; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    weekDays.push(days[date.getDay()]);
  }
  
  return weekDays;
};

// 生成近5个月的标签
export const getLastFiveMonths = () => {
  const months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
  const result = [];
  const now = new Date();
  const currentMonth = now.getMonth();
  
  for (let i = 4; i >= 0; i--) {
    const monthIndex = (currentMonth - i + 12) % 12;
    result.push(months[monthIndex]);
  }
  
  return result;
};

